<script>
	import {
		getStorage,
		ref,
		uploadBytesResumable,
		getDownloadURL,
	} from "firebase/storage";
	import { slugify } from "cando-util";
	import { formatFileSize } from "$lib/utilities/formatFileSize";
	import { getImageDimensions } from "$lib/utilities/getImageDimensions";
	import { getVideoDimensions } from "$lib/utilities/getVideoDimensions";

	export let docData; // data that get's stored in the document
	export let path = "uploads";
	export let handleChange = async () => {};
	export let key = "";
	export let itemId;

	let selectedFile;
	let progress = 0;

	const openFileInput = (e) => {
		const elem = document.getElementById(slugify(`${path}-fileInput`));
		elem.click();
	};

	const handleFileSelection = async (e) => {
		// so this basically would just set it up for preview...
		selectedFile = e.target.files[0];
		docData = {
			name: selectedFile.name,
			size: selectedFile.size,
			formattedSize: formatFileSize(selectedFile.size),
			type: selectedFile.type,
			path: `${path}/${selectedFile.name}`,
			blob: URL.createObjectURL(selectedFile),
		};
		if (selectedFile?.type.startsWith("image/")) {
			const { width, height } = await getImageDimensions(selectedFile);
			docData = { ...docData, width, height };
		}
		if (selectedFile?.type.startsWith("video/")) {
			const { width, height } = await getVideoDimensions(selectedFile);
			docData = { ...docData, width, height };
		}
	};

	const handleFileUpload = async (e) => {
		const storage = getStorage(); // Initialize Firebase Storage
		const fileRef = ref(storage, `${path}/${selectedFile.name}`);

		try {
			// Upload the file
			const uploadTask = uploadBytesResumable(fileRef, selectedFile);

			uploadTask.on("state_changed", {
				next: (snapshot) => {
					const { bytesTransferred, totalBytes } = snapshot;
					progress = (bytesTransferred / totalBytes) * 100;
				},
				error: (error) => {
					// Handle unsuccessful uploads
					console.log("upload error:", error);
				},
				complete: async () => {
					const downloadUrl = await getDownloadURL(fileRef);
					docData = {
						...docData,
						downloadUrl,
						updated: new Date().toISOString(),
					};
					delete docData.blob;

					await handleChange(e);

					progress = 0;
				},
			});
		} catch (error) {
			console.error("Error uploading file: ", error);
			alert("File upload failed.");
		}
	};
</script>

<input
	type="file"
	name={`${path} fileInput`}
	id={slugify(`${path}-fileInput`)}
	on:change={handleFileSelection}
	hidden
	{key}
/>

<button
	class="block m-auto btn btn-sm hover-ripple whitespace-nowrap"
	on:click|preventDefault={openFileInput}
	{key}
>
	{!docData?.name ? "Add" : "Change"} File
</button>

<button
	class={`block m-auto btn btn-sm ${!docData?.blob ? "opacity-50" : "hover-ripple"} whitespace-nowrap`}
	on:click={handleFileUpload}
	{itemId}
	{key}
	disabled={!docData?.blob}>Upload File</button
>

<div
	class={`block m-2 ${progress === 0 ? "hidden" : ""}`}
	id={slugify(`${path}-progress`)}
>
	<!-- <h3 class="text-center">...uploading file</h3> -->
	<progress
		id={slugify(`${path}-progressBar`)}
		class="progress"
		value={progress}
		max="100"
	></progress>
</div>
